import React from "react";
import styles from "./Divider.module.scss";

const Divider = ({ text, className }) => {
  return (
    <div className={`${styles.divider} ${className || ""}`}>
      {text && <span className={styles.text}>{text}</span>}
    </div>
  );
};

export default Divider;
